import script from "./PlatformDynamicsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformDynamicsDetail.vue?vue&type=script&setup=true&lang=js"

import "./PlatformDynamicsDetail.vue?vue&type=style&index=0&id=41f1f024&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enpzjpl/zjpl-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f1f024"]])

export default __exports__